import { useState } from "react";

export default function AuthUserConfirmation({ state, onChange, onSuccess, onError, authService }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const username = state.username || localStorage.getItem("username");
  const confirmationCode = state.confirmationCode;

  if (!username) {
    onSuccess({ action: "login" });
  }

  const handleConfirmation = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      if (!username) {
        setError("Please enter a valid username or email address.");
        return;
      }
      const result = await authService.confirmRegistration(username, confirmationCode);
      setLoading(false);

      if (typeof onSuccess === "function") {
        localStorage.removeItem("username");
        onSuccess({ action: "login", message: "Account confirmed. Please login.", response: result });
      }
    } catch (err) {
      setLoading(false);
      const errorMessage = err.message || "An error occurred during confirmation";
      setError(errorMessage);

      if (typeof onError === "function") {
        onError(err);
      }
    }
  };

  const handleResendCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      console.log("Resending confirmation code for", username);
      await authService.resendConfirmationCode(username);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      const errorMessage = err.message || "An error occurred resending confirmation code";
      setError(errorMessage);

      if (typeof onError === "function") {
        onError(err);
      }
    }
  };

  return (
    <div className="mx-auto w-full max-w-md">
      <form onSubmit={handleConfirmation} className="mb-4 rounded px-8 pt-6 pb-8">
        <h2 className="text-center">Confirm Registration</h2>

        <p className="my-4">
          A confirmation code has been sent to your email. Please enter it below to complete your registration.
        </p>

        {error && (
          <div className="relative mb-4 rounded border border-red-400 bg-red-100 px-4 py-3 text-red-700" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <div className="mb-4">
          <label className="mb-2 block text-sm font-bold" htmlFor="username">
            Username
          </label>
          <input
            className="input-text"
            id="username"
            type="text"
            placeholder="Username"
            value={username || ""}
            disabled={true}
            required
          />
        </div>

        <div className="mb-6">
          <label className="mb-2 block text-sm font-bold" htmlFor="confirmationCode">
            Confirmation Code
          </label>
          <input
            className="input-text"
            id="confirmationCode"
            type="text"
            placeholder="Enter your confirmation code"
            value={state.confirmationCode || ""}
            onChange={(e) => onChange("confirmationCode", e.target.value)}
            autoComplete="otp"
            required
          />
        </div>

        <div className="flex w-full items-center justify-between">
          <button
            className={`py-2 font-bold text-blue-500 text-white hover:text-blue-700 ${loading ? "cursor-not-allowed opacity-50" : ""}`}
            type="button"
            disabled={loading}
            onClick={handleResendCode}
          >
            Resend Code
          </button>

          <button
            className={`focus:shadow-outline rounded bg-blue-500 px-4 py-2 font-bold text-white hover:bg-blue-700 focus:outline-none ${loading ? "cursor-not-allowed opacity-50" : ""}`}
            type="submit"
            disabled={loading}
          >
            {loading ? "Confirming..." : "Confirm Registration"}
          </button>
        </div>
      </form>
    </div>
  );
}
